import React, { Component } from 'react';
import { Table,Button,Input, Row, Col,Select,Menu,Icon,Modal,Form,DatePicker,message,Radio, Breadcrumb, Checkbox} from 'antd';
import {action} from './'
import { connect } from 'react-redux';
import {Link} from 'react-router-dom';
import {getFilterColumns} from './columns'
import CreateTask from "./creat_task/view";
import axios from 'axios';
import $ from '$';
import API from '../../../API/api';
import {AUTHORITY} from '../../../utils/questionType';
import { getTagClassesAPI, getAllTaskTypeAPI } from '@/API';

const Search = Input.Search;
const Option = Select.Option;
const SubMenu = Menu.SubMenu;
const MenuItemGroup = Menu.ItemGroup;
const confirm = Modal.confirm;
const FormItem = Form.Item;
const RadioGroup = Radio.Group;


class MissionList extends Component{
    state={
        pagesize:10,
        selectedRowKeys: [], // Check here to configure the default column
        loading: false,
        columns: [],
        visible:false,
        currentPage:1,

        taskId:'',
        advanceSearch:false,
        totalWidth:1002,
        assignClerk:false,
        assignVerifier:false,
        exportStatic:false,
        exportStartTime:'',
        exportEndTime:'',
        query:'',
        searchType:'',
        searchVerifier:'',
        searchEntryUser:'',

        clerkList:[],
        groupList:[],
        verifierList:[],
        clerk:'',
        group:'',
        verifier1:'',
        verifier2:'',
        verifier3:'',
        checkTotalNum:'1',
        tagTaskModal: false ,// 打标签&解析任务modal
        tagClassesList: [], // 标签种类列表
        taskTypeList: [], // 任务类型
        tag_type: [], // 默认标签种类
        node_knowledge_type: [], // 默认任务类型
        is_spread: 1, // 是否泛化
        expChecked: true, // 创建解析任务
        tagChecked: true, // 创建打标签任务
    }
    columnsToDisplay={
        pre_assign:[],
        entrying:[],
        pre_check:[],
        checking:[],
        rework:[],
        check_pass:[],
        online_fail:[],
        online_ing:[],
        online_success:[]
    }
    onSelectChange = (selectedRowKeys) => {
        this.setState({ selectedRowKeys:selectedRowKeys });
    }
    onEditTask = (val) => {
        this.setState({taskId:val.task_id,visible:true})
    }
    getList=(...arg)=>{
        this.setState({selectedRowKeys:[]})
        this.props.getList(...arg)
    }
    handleClick = (e) => {
        this.setState({loading:true,currentPage:1});
        this.getList({
            page:1,
            pagesize:this.state.pagesize,
            stage_type:e.key,
            search:this.state.query,
            check_user:this.state.searchVerifier,
            relate_type:~~this.state.searchType,
            entry_user:this.state.searchEntryUser
        },()=>{
            let width = 0;
            for(let key in this.columnsToDisplay[e.key]){
                width += this.columnsToDisplay[e.key][key].width;
            }
            this.props.setCurrent(e.key)
            this.setState({
                columns:this.columnsToDisplay[e.key],
                loading:false,
                totalWidth:width
            });
        },()=>{
            this.setState({
                loading:false,
            });
        })
    }
    onIsAdvanceSearch = ()=>{
        this.setState({advanceSearch:!this.state.advanceSearch})
    }
    onAdvanceSearch = ()=>{
        this.setState({loading:true});
        this.getList({
            search:this.state.query,
            page:1,
            pagesize:this.state.pagesize,
            stage_type:this.props.current,
            check_user:this.state.searchVerifier,
            relate_type:~~this.state.searchType,
            entry_user:this.state.searchEntryUser
        },()=>{
            this.setState({
                loading:false,
            });
        })
    }
    onPageChange = (page,pageSize)=>{
        let param = {
            page: page,
            pagesize: pageSize,
            stage_type:this.props.current,
            check_user:this.state.searchVerifier,
            relate_type:~~this.state.searchType,
            entry_user:this.state.searchEntryUser
        }
        if(this.state.query != ''){
            param.search = this.state.query;
            
        }
        this.getList(param);
        this.setState({currentPage:page});
    }
    onSearch = () => {
        this.setState({loading:true});
        this.getList({page:1,pagesize:this.state.pagesize,stage_type:this.props.current,search:this.state.query},()=>{
            this.setState({
                loading:false,
            });
        })
    }
    clearSearch = () => {
        this.setState({loading:true});
        this.getList({page:1,pagesize:this.state.pagesize,stage_type:this.props.current},()=>{
            this.setState({
                loading:false,
                query:'',
                searchType:'',
                searchVerifier:'',
                searchEntryUser:''
            });
        })
    }
    onCancel = () => {
        this.setState({visible:false})
    }
    onShow = () => {
        this.setState({visible:true,taskId:''})
    }
    showDeleteConfirm = () => {
        const ids = this.state.selectedRowKeys;
        const me = this;
        confirm({
            title: '确定删除任务？',
            content: '删除任务后不可恢复，确定删除吗？',
            onOk() {
                return new Promise((resolve, reject) => {
                                axios.post(API.DEL_TASK, {task_id:ids}).then((res)=>{
                                    res = res.data;
                                    if (res.code === 0) {
                                        message.success("删除成功！");
                                        resolve();
                                        me.onRefreshList();
                                    }else{
                                        message.error(res.message);
                                        reject();
                                    }
                                },()=>{message.error("删除失败！")})})
            },
            onCancel() {},
        });
    }
    onGeneralizeTask = (add_explain,cb) => {//手动泛化

        axios.post(API.ENTRY_TASH_FANHUA, {task_id:this.state.selectedRowKeys}).then((res)=>{
            res = res.data
            if (res.code === 0) {
                message.success("手动泛化成功！")
                cb&&cb()
            }else{
                message.error(res.message)
            }
        },()=>{message.error("泛化失败！")})
    }


    onDeployTask = (add_extral,cb) => {

        axios.post(API.DEPLOY_TASK, {task_id:this.state.selectedRowKeys,add_extral}).then((res)=>{
            res = res.data
            if (res.code === 0) {
                message.success("申请上线成功！")
                this.onRefreshList();
                cb&&cb()
            }else{
                message.error(res.message)
            }
        },()=>{message.error("上线失败！")})
    }

    onDeployTaskCreatExplain=()=>{
        this.onDeployTask(1,()=>{this.setState({onDeployTaskCreatExplain:false})})
    }
    onCheckPass = () => {
        axios.post(API.CHECK_PASS, {task_id:this.state.selectedRowKeys}).then((res)=>{
            res = res.data
            if (res.code === 0) {
                message.success("审核通过！")
                this.onRefreshList();
            }else{
                message.error(res.message)
            }
        },()=>{message.error("网络错误！")})
    }
    onCheckRework = () => {
        axios.post(API.CHECK_REWORK, {task_id:this.state.selectedRowKeys}).then((res)=>{
            res = res.data
            if (res.code === 0) {
                message.success("已返工！")
                this.onRefreshList();
            }else{
                message.error(res.message)
            }
        },()=>{message.error("网络错误！")})
    }
    onResubmit = () => {
        axios.post(API.RESUBMIT, {task_id:this.state.selectedRowKeys}).then((res)=>{
            res = res.data
            if (res.code === 0) {
                message.success("提交成功！")
                this.onRefreshList();
            }else{
                message.error(res.message)
            }
        },()=>{message.error("网络错误！")})
    }
    onSubmit = () => {
        axios.post(API.ON_SUBMIT, {task_id:this.state.selectedRowKeys}).then((res)=>{
            res = res.data
            if (res.code === 0) {
                message.success("提交成功！")
                this.onRefreshList();
            }else{
                message.error(res.message)
            }
        },()=>{message.error("网络错误！")})
    }
    onRevocation = () => {
        axios.post(API.ON_REVOCATION, {task_id:this.state.selectedRowKeys}).then((res)=>{
            res = res.data
            if (res.code === 0) {
                message.success("提交成功！")
                this.onRefreshList();
            }else{
                message.error(res.message)
            }
        },()=>{message.error("网络错误！")})
    }

    onAssignClerk = () => {
        if(this.state.clerk){
            axios.post(API.ASSIGN_CLERK, {task_id:this.state.selectedRowKeys,user_id:this.state.clerk}).then((res)=>{
                res = res.data
                if (res.code === 0) {
                    this.setState({clerk:'',assignClerk:false,});
                    this.onRefreshList();
                }else{
                    message.error(res.message);
                }
            })
        }else {
            message.error("请选择录入员！")
        }

    }
    onAssignVerifier = () => {
        let user_id = []
        for(let i=0;i<this.state.checkTotalNum;i++){
            if(!this.state['verifier'+(i+1)]){
                return message.error(`请填写第${+i+1}轮审核员`)
            }
            user_id.push(this.state['verifier'+(i+1)])
        }
        if(user_id.length){
            axios.post(API.ASSIGN_VERIFIER, {task_id:this.state.selectedRowKeys,user_id,check_total_num:this.state.checkTotalNum}).then((res)=>{
                res = res.data
                if (res.code === 0) {
                    this.setState({verifier:'',assignVerifier:false,});
                    this.onRefreshList();
                }else{
                    message.error(res.message);
                }
            })
        }else {
            message.error("请选择校验员！")
        }
    }

    onAssignVerifierMod = () => {
        let user_id = []
        for(let i=0;i<this.state.checkTotalNum;i++){
            if(!this.state['verifier'+(i+1)]){
                return message.error(`请填写第${+i+1}轮审核员`)
            }
            user_id.push(this.state['verifier'+(i+1)])
        }
        user_id = user_id.splice((this.state.selected_check_num-1))
        if(user_id.length){
            axios.post(API.ASSIGN_VERIFIER_AGAIN, {task_id:this.state.selectedRowKeys,user_id,check_total_num:this.state.checkTotalNum}).then((res)=>{
                res = res.data
                if (res.code === 0) {
                    this.setState({verifier:'',assignVerifierMod:false,});
                    this.onRefreshList();
                }else{
                    message.error(res.message);
                    this.setState({verifier:'',assignVerifierMod:false,});

                }
            })
        }else {
            message.error("请选择校验员！")
        }
    }
    onRefreshList = (page) => {
        this.state.selectedRowKeys = [];
        this.getList({
            page:page?page:this.state.currentPage,
            pagesize:this.state.pagesize,
            stage_type:this.props.current,
            check_user:this.state.searchVerifier,
            relate_type:~~this.state.searchType,
            entry_user:this.state.searchEntryUser
        },()=>{
            this.setState({
                loading:false,
                query:'',
                searchType:'',
                searchVerifier:'',
                searchEntryUser:''
            });
        },()=>{
            this.setState({
                loading:false,
            });
        })
    }
    onStartChange = (value) => {
        this.setState({exportStartTime:value});
    }

    onEndChange = (value) => {
        this.setState({exportEndTime:value});
    }
    onGetExoprtStatic = ()=>{
        var form = $("<form>");   //定义一个form表单
        form.attr('style', 'display:none');   //在form表单中添加查询参数
        form.attr('target', '');
        form.attr('method', 'post');
        form.attr('action', API.GET_TASK_STATIC);
        var input1 = $('<input>');
        input1.attr('type', 'hidden');
        input1.attr('name', 'start_time');
        if(this.state.exportStartTime){
            input1.attr('value', this.state.exportStartTime.format('YYYY-MM-DD'));
        }
        var input2 = $('<input>');
        input2.attr('type', 'hidden');
        input2.attr('name', 'end_time');
        if(this.state.exportEndTime){
            input2.attr('value', this.state.exportEndTime.format('YYYY-MM-DD'));
        }
        $('body').append(form);  //将表单放置在web中
        form.append(input1);   //将查询参数控件提交到表单上
        form.append(input2);
        form.submit();
        this.setState({exportStatic:false})
    }

    componentWillReceiveProps(newProps){
        if(this.props.user!=newProps.user){
            //任务的9个阶段显示哪几个
            let role_qbox = newProps.user.role_qbox
            if(!role_qbox){
                return;
            }
            this.columnsToDisplay={
                pre_assign:getFilterColumns(role_qbox,'pre_assign'),
                entrying:getFilterColumns(role_qbox,'entrying'),
                pre_check:getFilterColumns(role_qbox,'pre_check'),
                checking:getFilterColumns(role_qbox,'checking'),
                rework:getFilterColumns(role_qbox,'rework'),
                check_pass:getFilterColumns(role_qbox,'check_pass'),
                online_fail:getFilterColumns(role_qbox,'online_fail'),
                online_ing:getFilterColumns(role_qbox,'online_ing'),
                online_success:getFilterColumns(role_qbox,'online_success'),
            }
            if(role_qbox.buttons.editTask){
                this.columnsToDisplay.pre_assign.pop()
                this.columnsToDisplay.pre_assign.push({
                    title: '操作',
                    dataIndex: 'options',
                    key: 'options',
                    width:100,
                    render: (text, record) => (
                        <span>
                            {
                                record.resource_url&&record.resource_url!==''&&
                                <Link to={record.resource_url}>查看资源</Link>
                            }
                            <Button style={{fontSize: 11}} type="primary" onClick={()=>this.onEditTask(record)} size="small">编辑任务</Button>
                        </span>
                    )
                })
            }
            if(this.props.current==='pre_assign'){//选中待审核的情况和初始化相同处理
                if(role_qbox.columns[0].some(d=>d>0)){ //有组权限 从待分配开始
                    this.props.setCurrent('pre_assign')

                }
                if(!role_qbox.columns[0].some(d=>d>0)){ //录入员从录入中开始
                    this.props.setCurrent('entrying')

                }
                if(!role_qbox.columns[2].some(d=>d>0)){  //审核员从审核中开始
                    this.props.setCurrent('checking')
                }
            }
            setTimeout(()=>{
                this.state.columns = this.columnsToDisplay[this.props.current]


                let width = 0;
                for(let key in this.columnsToDisplay[this.props.current]){
                    width += this.columnsToDisplay[this.props.current][key].width;
                }
                this.state.totalWidth=width
                this.props.getList({page:1,pagesize:this.state.pagesize,stage_type:this.props.current});//获得可见的选中任务阶段的列表

                if(role_qbox.buttons.assignClerk){
                    axios.post(API.GET_CLERK_LIST, {}).then((res)=>{
                        res = res.data
                        if (res.code === 0) {
                            this.setState({clerkList:res.data.list});
                        }else{
                            message.error(res.message)
                        }
                    },()=>{message.error("网络错误！")});
                }
                if(role_qbox.buttons.assignVerifier) {
                    axios.post(API.GET_VERIFIER_LIST, {}).then((res)=>{
                        res = res.data
                        if (res.code === 0) {
                            this.setState({verifierList:res.data.list})
                        }else{
                            message.error(res.message)
                        }
                    },()=>{message.error("网络错误！")})
                }
            },0)

        }
    }
    componentDidMount(){
        let setCurrent=()=>{
            if(this.props.user.role_qbox){
                //任务的9个阶段显示哪几个
                let role_qbox = this.props.user.role_qbox
                if(!role_qbox){
                    return;
                }
                this.columnsToDisplay={
                    pre_assign:getFilterColumns(role_qbox,'pre_assign'),
                    entrying:getFilterColumns(role_qbox,'entrying'),
                    pre_check:getFilterColumns(role_qbox,'pre_check'),
                    checking:getFilterColumns(role_qbox,'checking'),
                    rework:getFilterColumns(role_qbox,'rework'),
                    check_pass:getFilterColumns(role_qbox,'check_pass'),
                    online_fail:getFilterColumns(role_qbox,'online_fail'),
                    online_ing:getFilterColumns(role_qbox,'online_ing'),
                    online_success:getFilterColumns(role_qbox,'online_success'),
                }
                if(role_qbox.buttons.editTask){
                    this.columnsToDisplay.pre_assign.pop()
                    this.columnsToDisplay.pre_assign.push({
                        title: '操作',
                        dataIndex: 'options',
                        key: 'options',
                        width:100,
                        render: (text, record) => (
                            <span>
                            {
                                record.resource_url&&record.resource_url!==''&&
                                <Link to={record.resource_url}>查看资源</Link>
                            }
                                <Button style={{fontSize: 11}} type="primary" onClick={()=>this.onEditTask(record)} size="small">编辑任务</Button>
                        </span>
                        )
                    })
                }

                if(this.props.current==='pre_assign'){//选中待审核的情况和初始化相同处理
                    if(role_qbox.columns[0].some(d=>d>0)){ //有组权限 从待分配开始
                        this.props.setCurrent('pre_assign')
                    }
                    if(!(role_qbox.columns[0].some(d=>d>0))){ //录入员从录入中开始
                        this.props.setCurrent('entrying')
                    }
                    if(!role_qbox.columns[2].some(d=>d>0)){  //审核员从审核中开始
                        this.props.setCurrent('checking')
                    }

                }
                setTimeout(()=>{
                    this.state.columns = this.columnsToDisplay[this.props.current]

                    let width = 0;
                    for(let key in this.columnsToDisplay[this.props.current]){
                        width += this.columnsToDisplay[this.props.current][key].width;
                    }
                    this.state.totalWidth=width
                    this.props.getList({page:1,pagesize:this.state.pagesize,stage_type:this.props.current});//获得可见的选中任务阶段的列表

                    if(role_qbox.buttons.assignClerk){
                        axios.post(API.GET_CLERK_LIST, {}).then((res)=>{
                            res = res.data
                            if (res.code === 0) {
                                this.setState({clerkList:res.data.list});
                            }else{
                                message.error(res.message)
                            }
                        },()=>{message.error("网络错误！")});
                    }
                    if(role_qbox.buttons.assignVerifier) {
                        axios.post(API.GET_VERIFIER_LIST, {}).then((res)=>{
                            res = res.data
                            if (res.code === 0) {
                                this.setState({verifierList:res.data.list})
                            }else{
                                message.error(res.message)
                            }
                        },()=>{message.error("网络错误！")})
                    }
                },0)

            }else{
                setTimeout(()=>{setCurrent()},500)
            }
        }
        setCurrent()


    }
    componentWillUnmount(){
        this.columnsToDisplay['pre_assign'].pop();
    }
    changeCheckingNow=()=>{
        let flag = true
        let totalflag = true
        let selected_check_num,selected_check_total_num,check_user;
        if(this.state.selectedRowKeys&&this.state.selectedRowKeys.length){
            this.state.selectedRowKeys.forEach((task_id)=>{
                this.props.list.forEach(d=>{
                    if(d.task_id==task_id){
                        if(!selected_check_num){selected_check_num = d.check_num}
                        if(!selected_check_total_num){selected_check_total_num = d.check_total_num}

                        if(!check_user){check_user = d.check_user}
                        if(selected_check_num!==d.check_num){flag = false}
                        if(selected_check_total_num!==d.check_total_num){totalflag = false}
                    }
                })
            })
        }
        let check_user_arr = check_user.split(',')
        if(!flag){return message.error('选中的多个任务的当前轮数不同')}
        if(!totalflag){return message.error('选中的多个任务的总轮数不同')}
        this.setState({assignVerifierMod:true,selected_check_num,checkTotalNum:selected_check_total_num,verifier1:check_user_arr[0]||'',verifier2:check_user_arr[1]||'',verifier3:check_user_arr[2]||''})
    }

    // 取消打标签&解析任务modal
    handleCancel = () => {
        this.setState({
            tagTaskModal: false
        })
    }

    // 确认打标签&解析任务
    handleOk = () => {
        let { expChecked, tagChecked, tag_type, node_knowledge_type, is_spread } = this.state;
        let new_type = [...node_knowledge_type];
        let add_extral = {};
        
        if (new_type.includes('-1')) {
            let numIndex = new_type.indexOf('-1');
            new_type.splice(numIndex, 1);
        }
        
        if (expChecked) {
            add_extral.explain = {};
        }

        if (tagChecked) {
            if (tag_type.length < 1) {
                message.error('请选择标签种类！')
                return;
            }
            if (new_type.length < 1) {
                message.error('请选择类型！')
                return;
            }
            add_extral.qselect = {
                tag_type,
                is_spread,
                node_knowledge_type: new_type
            }
        }
        // 接口
        
        this.onDeployTask(add_extral, () => {
            this.handleCancel();
        });
    }

    // 标签种类被选中时
    handleSelected = (value, option) => {
        const { tagClassesList, tag_type } = this.state;
        const newArr = tagClassesList.map(item => item.id.toString());

        if (value == '-1') { // 全部
            this.setState({tag_type: newArr});
        }
        else {
            let tagType = [...tag_type];
            tagType.push(value);
            if (tagType.length + 1 === newArr.length) {
                this.setState({tag_type: newArr});
            }
            else {
                this.setState({tag_type: tagType});
            } 
        }  
    }

    // 标签种类取消时
    handleDeselect = (value, option) => {
        let { tagClassesList, tag_type } = this.state;
        const newArr = tagClassesList.map(item => item.id.toString());
        if (value == '-1') { // 取消全部
            this.setState({tag_type: []});
        }
        else {
            let tagType = [...tag_type];
            const delValue1 = tagType.indexOf(value);
            const delValue2 = tagType.indexOf('-1');
            tagType.splice(delValue1, 1)
            delValue2 != '-1' && tagType.splice(delValue2, 1);

            this.setState({tag_type: tagType});
        }
    }

    // 知识点类型被选中时
    handleTypeSelected = (value, option) => {
        const { taskTypeList, node_knowledge_type } = this.state;
        const newArr = taskTypeList.map(item => item.id.toString());

        if (value == '-1') { // 全部
            this.setState({node_knowledge_type: newArr});
        }
        else {
            let tagType = [...node_knowledge_type];
            tagType.push(value);
            if (tagType.length + 1 === newArr.length) {
                this.setState({node_knowledge_type: newArr});
            }
            else {
                this.setState({node_knowledge_type: tagType});
            } 
        }  
    }

    // 知识点类型被取消时
    handleTypeDeselect = (value, option) => {
        let { taskTypeList, node_knowledge_type } = this.state;
        const newArr = taskTypeList.map(item => item.id.toString());

        if (value == '-1') { // 取消全部
            this.setState({node_knowledge_type: []});
        }
        else {
            let tagType = [...node_knowledge_type];
            const delValue1 = tagType.indexOf(value);
            const delValue2 = tagType.indexOf('-1');
            tagType.splice(delValue1, 1)
            delValue2 != '-1' && tagType.splice(delValue2, 1);

            this.setState({node_knowledge_type: tagType});
        }
    }

    // 是否泛化
    handleGeneralizeChange = value => {
        this.setState({is_spread: value})
    }

    // 是否创建解析任务
    onChangeExp = e => {
        this.setState({expChecked: e.target.checked})
    }

    // 是否创建打标签任务
    onChangeTag = e => {
        this.setState({tagChecked: e.target.checked})
    }

    // 审核通过-入库
    onDeployTaskNew = () => {
        let { subject } = this.props;
        if (+subject !== 0) {
            this.onDeployTask({}, () => {
                this.handleCancel();
            });
            return;
        }
        // 获取标签种类
        getTagClassesAPI({}).then(Sucdata => { // 成功
            let dataTagList = Sucdata.data;
            let tag_type = dataTagList.map(item => item.id.toString());
            this.setState({tagClassesList: dataTagList, tag_type});
        }, errData => { // 失败
            console.log(errData);
            this.setState({tagClassesList: []});
        });

        // 获取任务类型
        getAllTaskTypeAPI({}).then(Sucdata => {
            let dataTaskList = Sucdata.data.node_knowledge_type;
            dataTaskList.unshift({id: "-1", name: '全部'});
            this.setState({taskTypeList: dataTaskList});
        }, errData => {
            console.log(errData);
            this.setState({taskTypeList: []});
        })

        this.setState({
            tagTaskModal: true
        });

    }

    render(){
        const { currentPage,tagTaskModal, tagClassesList, taskTypeList, tag_type, node_knowledge_type, is_spread, expChecked, tagChecked } = this.state;
        let role_qbox = this.props.user.role_qbox
        if(!role_qbox){return null}
        const data = [];
        this.props.list && this.props.list.forEach((val)=>{

            data.push(Object.assign({},val,{
                key: val.task_id,
                task_id:val.task_id,
                name:val.name,
                type:val.type,
                create_time: val.create_time && val.create_time.split(' ')[0],
                status:val.stage_name && val.stage_name,
                statics:((val.question_count&&val.question_count)||' ')+' - '+((val.question_pass_count&&val.question_pass_count)||' ')+' - '+((val.question_rework_count&&val.question_rework_count)||' '),//暂空
                input_end_time:((val.entry_finish_time &&val.entry_finish_time.split(' ')[0])||'')+'/'+((val.entry_dead_time && val.entry_dead_time.split(' ')[0])||''),
                deadline: val.check_dead_time &&val.check_dead_time.split(' ')[0],
                clerk: val.entry_user_name && val.entry_user_name,//录入人
                verifier: val.check_user_name && val.check_user_name,//审核人
                clerkLeader: val.group_admin_name && val.group_admin_name,//审核组长
                resource_url:val.resource_url,

            }));
        })
        const {selectedRowKeys } = this.state;
        const rowSelection = {
            selectedRowKeys,
            onChange: this.onSelectChange,
        };
        const hasSelected = selectedRowKeys.length > 0;
        const sex = ['女','女','男'];
        const state = ['忙碌','一般','空闲']
        const getOptionButton = ()=>{
            let result = '';
            switch (this.props.current){
                case 'pre_assign':
                    result =<Col span={12}>
                        {
                            role_qbox.buttons.addTask===1 && //创建任务
                            <Button style={{fontSize: 12,marginRight:10}} type="primary" onClick={this.onShow}>创建任务</Button>

                        }
                        

                        {
                            role_qbox.buttons.deleteTask===1&& // 删除任务：   任务管理权限可显示
                            <Button style={{fontSize: 12,marginRight:10}} type="primary" disabled={!hasSelected} onClick={this.showDeleteConfirm}>删除任务</Button>

                        }


                        {
                            role_qbox.buttons.assignClerk===1&&  // 分配录入员： 任务管理权限、组管理权限 可显示
                        <Button style={{fontSize: 12,marginRight:10}} type="primary" disabled={!hasSelected} onClick={()=>this.setState({assignClerk:true})}>分配录入员</Button>
                        }
						{this.state.visible && <CreateTask user={this.props.user} onCancel={this.onCancel} onShow={this.onShow} visible={this.state.visible} taskId={this.state.taskId} refresh={(val)=>{this.onRefreshList(val||this.state.currentPage)}}/>}
                        <Modal title="分配录入员" visible={this.state.assignClerk} onOk={this.onAssignClerk} onCancel={()=>this.setState({assignClerk:false})}>
                            <span style={{marginLeft:30}}>分配录入员：</span>
                            <Select
                                showSearch
                                placeholder="请选择录入员"
                                style={{width:'61.4%'}}
                                filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                onChange={(val)=>{this.setState({clerk:val})}}
                                value={this.state.clerk}

                            >
                                {
                                    this.state.clerkList&&this.state.clerkList.map(item =>
                                        <Option key={item.user_id} value={item.user_id.toString()}>{item.name + '-' + item.mobile + '-' +item.cur_task_count}</Option>)
                                }
                            </Select>
                        </Modal>
                    </Col>
                    break;
                case 'entrying':
                    result =<Col span={12}>
                        {
                            role_qbox.buttons.revocation===1&&  //录入中的撤回：任务管理权限 组管理权限  可显示
                            <Button style={{fontSize: 12,marginRight:10}} type="primary" disabled={!hasSelected} onClick={this.onRevocation}>撤&nbsp;&nbsp;回</Button>
                        }
                        {
                            role_qbox.buttons.submit===1&&//录入中的提交：任务管理权限 组管理权限  可显示
                            <Button style={{fontSize: 12,marginRight:10}} type="primary" disabled={!hasSelected} onClick={this.onSubmit}>提&nbsp;&nbsp;交</Button>
                        }
                    </Col>
                    break;
                case 'pre_check':
                    result =<Col span={12}>
                        {
                            role_qbox.buttons.assignVerifier===1&& //待审核 校验分配：任务管理权限 组管理权限  可显示
                            <Button style={{fontSize: 12,marginRight:10}} type="primary" disabled={!hasSelected} onClick={()=>this.setState({assignVerifier:true,verifier1:'',verifier2:'',verifier3:''})}>校验分配</Button>

                        }
                        <Modal title="分配审核员" visible={this.state.assignVerifier} onOk={this.onAssignVerifier} onCancel={()=>this.setState({assignVerifier:false})}>
                            {
                                this.props.subject!=='0'&&
                                <div>
                                    <span style={{marginLeft:30}}>选择审核轮次：</span>
                                    <Select
                                        style={{width:'61.4%'}}
                                        onChange={(val)=>{this.setState({checkTotalNum:val})}}
                                        value={this.state.checkTotalNum}
                                    >
                                        <Option key={1} value={'1'}>一次</Option>
                                        <Option key={2} value={'2'}>二次</Option>
                                        <Option key={3} value={'3'}>三次</Option>
                                    </Select>
                                </div>
                            }

                            {
                                this.state.checkTotalNum&&
                                ['一轮','二轮','三轮'].splice(0,this.state.checkTotalNum).map((item,key)=>
                                    <div key={key} style={{marginTop:15}}>
                                        <span style={{marginLeft:30}}>&nbsp;&nbsp;&nbsp;&nbsp;{this.props.subject==='0'?'    ':item}审核员：</span>
                                        <Select
                                            showSearch
                                            placeholder="请选择审核员"
                                            style={{width:'61.4%'}}
                                            filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                            onChange={(val)=>{this.setState({['verifier'+(key+1)]:val})}}
                                            value={this.state['verifier'+(key+1)]}
                                        >
                                            {
                                                this.state.verifierList&&this.state.verifierList.map(item =>
                                                    <Option key={item.user_id} value={item.user_id.toString()}>{item.name + '-' + item.mobile +  '-' +item.cur_task_count}</Option>)
                                            }
                                        </Select>
                                    </div>
                                )

                            }

                        </Modal>
                    </Col>
                    break;
                case 'checking':
                    result =<Col span={12}>
                        {
                            role_qbox.buttons.checkRework===1&& //返工
                            <Button style={{fontSize: 12,marginRight:10}} type="primary" disabled={!hasSelected} onClick={this.onCheckRework}>返工</Button>
                        }
                        {
                            role_qbox.buttons.checkPass===1&& //审核完成：任务管理权限 审核权限  可显示
                            <Button style={{fontSize: 12,marginRight:10}} type="primary" disabled={!hasSelected} onClick={this.onCheckPass}>审核完成</Button>
                        }
                        {
                            role_qbox.buttons.assignVerifier===1&& //待审核 校验分配：任务管理权限 组管理权限  可显示
                            <Button style={{fontSize: 12,marginRight:10}} type="primary" disabled={!hasSelected} onClick={()=>{this.changeCheckingNow()} }>校验分配</Button>

                        }
                        <Modal title="变更审核人" visible={this.state.assignVerifierMod} onOk={this.onAssignVerifierMod} onCancel={()=>this.setState({assignVerifierMod:false})}>

                            {
                                this.props.subject!=='0'&&
                                <div>
                                    <span style={{marginLeft:30}}>选择审核轮次：</span>
                                    <Select
                                        style={{width:'61.4%'}}
                                        onChange={(val)=>{this.setState({checkTotalNum:val})}}
                                        value={this.state.checkTotalNum}
                                        disabled
                                    >
                                        <Option key={1} value={'1'} >一次</Option>
                                        <Option key={2} value={'2'} >二次</Option>
                                        <Option key={3} value={'3'} >三次</Option>
                                    </Select>
                                </div>
                            }

                            {
                                this.state.checkTotalNum&&
                                ['一轮','二轮','三轮'].splice(0,this.state.checkTotalNum).map((item,key)=>
                                    <div key={key} style={{marginTop:15}}>
                                        <span style={{marginLeft:30}}>&nbsp;&nbsp;&nbsp;&nbsp;{this.props.subject==='0'?'    ':item}审核员：</span>
                                        <Select
                                            showSearch
                                            placeholder="请选择审核员"
                                            style={{width:'61.4%'}}
                                            filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                            onChange={(val)=>{this.setState({['verifier'+(key+1)]:val})}}
                                            value={this.state['verifier'+(key+1)]}
                                            disabled={this.state.selected_check_num>(key+1)}
                                        >
                                            {
                                                this.state.verifierList&&this.state.verifierList.map(item =>
                                                    <Option key={item.user_id} value={item.user_id.toString()}>{item.name + '-' + item.mobile +  '-' +item.cur_task_count}</Option>)
                                            }
                                        </Select>
                                    </div>
                                )

                            }

                        </Modal>
                    </Col>
                    break;
                case 'rework':
                    result =<Col span={12}>
                        {
                            role_qbox.buttons.resubmit===1 && //提交：任务管理权限 录入员权限  可显示
                            <Button style={{fontSize: 12,marginRight:10}} type="primary" disabled={!hasSelected} onClick={this.onResubmit}>提&nbsp;&nbsp;交</Button>
                        }
                    </Col>
                    break;
                case 'check_pass':
                    result =<Col span={12}>
                        {
                            role_qbox.buttons.deployTask===1&& //入库：任务管理权限  可显示
                            <Button style={{fontSize: 12,marginRight:10}} type="primary" disabled={!hasSelected} onClick={()=>{this.onDeployTaskNew()}}>入&nbsp;&nbsp;库</Button>
                        }
                        <Modal
                            title="是否创建打标签&解析任务？"
                            visible={tagTaskModal}
                            cancelText="取消"
                            okText="确认"
                            onOk={this.handleOk}
                            onCancel={this.handleCancel}>
                            <Row gutter={40}>
                                <Col span={10}>
                                    <Checkbox checked={expChecked} onChange={e => this.onChangeExp(e)}>创建解析任务</Checkbox>
                                </Col>
                                <Col span={14}>
                                    <Checkbox checked={tagChecked} onChange={e => this.onChangeTag(e)}>创建打标签任务</Checkbox>
                                    <div style={{marginTop: '10px', display: 'flex', alignItems: 'center'}}>
                                        <label style={{display: 'inline-block', width: '70px', textAlign: 'right'}}>标签种类：</label>
                                        <Select
                                            className="tag-selected"
                                            onSelect={this.handleSelected}
                                            onDeselect={this.handleDeselect}
                                            value={tag_type}
                                            mode={"multiple"}
                                            style={{flex: 1}}>
                                            {
                                                tagClassesList && tagClassesList.length > 0 ? tagClassesList.map(item => 
                                                    <Option key={item.id} value={item.id.toString()}>{item.name}</Option>
                                                ) : null
                                            }
                                        </Select>
                                    </div>
                                    <div style={{marginTop: '10px',  display: 'flex', alignItems: 'center'}}>
                                        <label style={{display: 'inline-block', width: '70px', textAlign: 'right'}}>类型：</label>
                                        <Select
                                            className="tag-selected"
                                            onSelect={this.handleTypeSelected}
                                            onDeselect={this.handleTypeDeselect}
                                            value={node_knowledge_type}
                                            mode={"multiple"}
                                            style={{flex: 1}}>
                                            {
                                                taskTypeList && taskTypeList.length > 0 ? taskTypeList.map(item => 
                                                    <Option key={item.id} value={item.id}>{item.name}</Option>
                                                ) : null
                                            }
                                            
                                        </Select>
                                    </div>
                                    <div style={{marginTop: '10px', display: 'flex', alignItems: 'center'}}>
                                        <label style={{display: 'inline-block', width: '70px', textAlign: 'right'}}>是否泛化：</label>
                                        <RadioGroup
                                            onChange={this.handleGeneralizeChange}
                                            defaultValue={is_spread}>
                                            <Radio value={1}>泛化</Radio>
                                            <Radio value={2}>不泛化</Radio>
                                        </RadioGroup>
                                    </div>
                                </Col>
                            </Row>
                        </Modal>
                        {
                            // role_qbox.buttons.deployTask===1&& //入库：任务管理权限  可显示
                            // this.props.subject==='0'&&//数学学科才有
                            // <Button style={{fontSize: 12,marginRight:10}} type="primary" disabled={!hasSelected} onClick={()=>{this.setState({onDeployTaskCreatExplain:true})}}>入库并创建解析任务</Button>
                        }
                        {
                            // <Modal width={250} title='' visible={this.state.onDeployTaskCreatExplain}
                            //        closable={false}
                            //        footer={null}
                            //        onCancel={()=>this.setState({onDeployTaskCreatExplain:false})}>
                            //     <div>
                            //         <div style={{textAlign:'center',padding:'25px 0',fontSize:16,fontWeight:'500'}}>是否创建打标签&解析任务？</div>
                            //         <div style={{marginTop:25,textAlign:'center'}}>
                            //             <Button onClick={()=>this.setState({onDeployTaskCreatExplain:false})}>
                            //                 取消
                            //             </Button>
                            //             <Button style={{marginLeft:35}} type={'primary'} onClick={this.onDeployTaskCreatExplain}>
                            //                 确定
                            //             </Button>
                            //         </div>
                            //     </div>
                            // </Modal>
                        }
                        
                    </Col>
                    break;
                case 'online_success':
                    result =<Col span={12}>
                        {
                            role_qbox.buttons.deployTask===1 && +this.props.subject === 0 && //手动泛化
                            <Button style={{fontSize: 12,marginRight:10}} type="primary" onClick={()=>{this.onGeneralizeTask()}}>手动泛化</Button>
                        }
                    </Col>
                    break;
                case 'online_ing':
                    result =<Col span={12}></Col>
                    break;
                case 'online_fail':
                    result =<Col span={12}>
                        {
                            role_qbox.buttons.deployTask===1&& //入库：任务管理权限  可显示
                            <Button style={{fontSize: 12,marginRight:10}} type="primary" disabled={!hasSelected} onClick={()=>{this.onDeployTask()}}>入&nbsp;&nbsp;库</Button>
                        }
                    </Col>
                    break;
                default:
                    result =<Col span={12} style={this.state.advanceSearch?{marginTop:66}:{}}></Col>
                    break;
            }
            return result

        }
        let disabledEndDate = (endValue) => {
            const startValue = this.state.exportStartTime;
            if (!endValue || !startValue) {
                return false;
            }
            return endValue.valueOf() <= startValue.valueOf();
        }
        let disabledStartDate = (current) => {
            return current && current.valueOf() >= Date.now();
        }
        return(
            <div>
                <Breadcrumb>
                    <Breadcrumb.Item style={{fontSize:20}}>
                        <span>题盒子</span>
                    </Breadcrumb.Item>
                </Breadcrumb>
                <Row style={{marginTop:15}}>
                    <Col span={24}>
                        {
                            role_qbox.buttons.advancedSearch?
                            // this.state.advanceSearch?
                                <div className={'searchHead'}>
                                    <Row style={{marginBottom:5}}>
                                        <div style={{fontSize: 14,marginLeft:'20px',display:'inline-block'}}>
                                            <label style={{width:'70px',display:'inline-block'}} htmlFor="search_type">题库类型 ：</label>
                                            <Select value={this.state.searchType} style={{ width: 120 }} onChange={(val)=>{this.setState({searchType:val})}} id="search_type">
                                                <Option value="1">章节</Option>
                                                <Option value="2">试卷</Option>
                                                <Option value="4">口算</Option>
                                                <Option value="11">教辅</Option>
                                            </Select>
                                        </div>
                                        <div style={{fontSize: 14,marginLeft:'40px',display:'inline-block'}}>
                                            <label style={{width:'70px',display:'inline-block'}} htmlFor="search_verifier">审核人 ：</label>
                                            <Select value={this.state.searchVerifier}
                                                    style={{ width: 120 }}
                                                    showSearch
                                                    filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                                    onChange={(val)=>{this.setState({searchVerifier:val})}} id="search_verifier">
                                                {
                                                    this.state.verifierList&&this.state.verifierList.map(item =>
                                                        <Option key={item.user_id} value={item.user_id.toString()}>{item.name}</Option>)
                                                }
                                            </Select>
                                        </div>
                                        <div style={{fontSize: 14,marginLeft:'40px',display:'inline-block'}}>
                                            <label style={{width:'70px',display:'inline-block'}}>录入人 ：</label>
                                            <Select value={this.state.searchEntryUser}
                                                    style={{ width: 120 }}
                                                    showSearch
                                                    filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}

                                                    onChange={(val)=>{this.setState({searchEntryUser:val})}} >
                                                {
                                                    this.state.clerkList&&this.state.clerkList.map((item,i) =>
                                                        <Option key={item.user_id} value={item.user_id.toString()}>{item.name}</Option>)
                                                }
                                            </Select>
                                        </div>
                                    </Row>
                                    <Row style={{marginTop:10}}>
                                        <div style={{fontSize: 14,marginLeft:'20px',display:'inline-block'}}>
                                            {/*<Icon style={{fontSize:20,lineHeight:'28px',marginRight:5,color:'#d9d9d9',verticalAlign:'bottom'}} type="up-circle-o" onClick={this.onIsAdvanceSearch}/>*/}
                                            <Search
                                                placeholder="输入关键字"
                                                style={{ width: 520,marginRight:10}}
                                                onSearch={this.onAdvanceSearch}
                                                onChange={(e)=>this.setState({query:e.target.value})}
                                                value={this.state.query}
                                            />
                                            <Button style={{fontSize: 12,marginLeft:'20px'}} type="primary" onClick={this.onAdvanceSearch}>搜索</Button>
                                            <Button style={{fontSize: 12,marginLeft:'120px'}} type="danger" onClick={this.clearSearch}>清空</Button>
                                        </div>
                                    </Row>
                                </div>:
                                <div style={{fontSize: 14,marginLeft:'20px',display:'inline-block',float:'left'}}>
                                    {/*{*/}
                                        {/*role_qbox.buttons.advancedSearch===1&&*/}
                                        {/*<Icon style={{fontSize:20,lineHeight:'28px',marginRight:5,color:'#d9d9d9',verticalAlign:'bottom'}} type="down-circle-o" onClick={this.onIsAdvanceSearch}/>*/}

                                    {/*}*/}
                                    <Search
                                        placeholder="输入关键字"
                                        style={{width:220,marginRight:10}}
                                        onSearch={this.onSearch}
                                        value={this.state.query}
                                        onChange={(e)=>this.setState({query:e.target.value})}
                                    />
                                    <Button style={{fontSize: 12,marginLeft:'20px'}} type="primary" onClick={this.onSearch}>搜索</Button>
                                    <Button style={{fontSize: 12,marginLeft:'120px'}} type="danger" onClick={this.clearSearch}>清空</Button>
                                </div>
                        }
                    </Col>
                </Row>
                <Row style={{marginTop:10}}>
                    <Col span={24}>
                        <div style={{fontSize:12}}>
                            <Menu
                                onClick={this.handleClick}
                                selectedKeys={[this.props.current]}
                                mode="horizontal"
                                style={{marginBottom:5,backgroundColor:'#f7f7f7',padding:'0 15px',borderRadius:6}}
                            >
                                {
                                    role_qbox.columns[0].some(d=>d>0)&&
                                    <Menu.Item key="pre_assign">待分配</Menu.Item>
                                }
                                {
                                    role_qbox.columns[1].some(d=>d>0)&&
                                    <Menu.Item key="entrying">录入中</Menu.Item>
                                }
                                {
                                    role_qbox.columns[2].some(d=>d>0)&&
                                    <Menu.Item key="pre_check">待审核</Menu.Item>
                                }
                                {
                                    role_qbox.columns[3].some(d=>d>0)&&
                                    <Menu.Item key="checking">审核中</Menu.Item>
                                }
                                {
                                    role_qbox.columns[4].some(d=>d>0)&&
                                    <Menu.Item key="rework">返工</Menu.Item>
                                }
                                {
                                    role_qbox.columns[5].some(d=>d>0)&&
                                    <Menu.Item key="check_pass">审核通过</Menu.Item>
                                }
                                {
                                    role_qbox.columns[6].some(d=>d>0)&&
                                    <Menu.Item key="online_ing">入库中</Menu.Item>
                                }
                                {
                                    role_qbox.columns[7].some(d=>d>0)&&

                                    <Menu.Item key="online_fail">入库失败</Menu.Item>
                                }
                                {
                                    role_qbox.columns[8].some(d=>d>0)&&
                                    <Menu.Item key="online_success">已入库</Menu.Item>
                                }

                            </Menu>
                        </div>
                    </Col>
                </Row>
                <Row style={{marginBottom:5}}>
                    {
                        getOptionButton()
                    }
                    <Col span={12}>
                        <div style={{fontSize:12,float:'right',marginRight:30}}>
                            {
                                role_qbox.buttons.errorduty===1 &&//解析检错
                                <Link className='ant-btn ant-btn-primary' style={{fontSize: 12,marginRight:30,background:'red',outline:'none',border:'none',verticalAlign:'middle',lineHeight:'28px'}} to={`/questionbox/duty/`}>错题追责</Link>

                            }
                            {
                                role_qbox.buttons.statics===1 &&//导出
                                <Button style={{fontSize: 12}} type="primary" onClick={()=>this.setState({exportStatic:true})}>任务结算导出</Button>
                            }
                            <Modal title="任务结算导出" visible={this.state.exportStatic} onOk={this.onGetExoprtStatic} onCancel={()=>this.setState({exportStatic:false})}>
                                <DatePicker
                                    format="YYYY-MM-DD"
                                    placeholder={'开始时间'}
                                    style={{marginRight:20}}
                                    onChange={this.onStartChange}
                                    disabledDate={disabledStartDate}
                                />
                                <DatePicker
                                    format="YYYY-MM-DD"
                                    placeholder={'结束时间'}
                                    onChange={this.onEndChange}
                                    disabledDate={disabledEndDate}
                                />
                            </Modal>
                        </div>
                    </Col>
                </Row>
                <Row >
                    <Table rowSelection={rowSelection} columns={this.state.columns} dataSource={data} pagination={{ current:currentPage,pageSize: +this.state.pagesize,total:this.props.total,onChange:this.onPageChange }} loading={this.state.loading} scroll={{ x: this.state.totalWidth + 62 }}/>
                </Row>
            </div>
        );
    }

}
const mapStateTopProps = (state) => {
    return {
        current:state.questionBox.missionList.current,
        list:state.questionBox.missionList.list,
        total:state.questionBox.missionList.total?state.questionBox.missionList.total:10,
        user:state.user,
        subject:state.user.subject,
    };
}
const mapDispatchToProps = dispatch => {
    return {
        getList: (val,callback,error) => {
            dispatch(action.getMissionList(val,callback,error));
        },
        setCurrent: (val) => {
            dispatch(action.setCurrent(val));
        },
    }
};

export default connect(mapStateTopProps,mapDispatchToProps)(MissionList);


// WEBPACK FOOTER //
// ./src/entry_app/question_box/mission_list/view.js